import React from 'react'
import Highcharts from 'highcharts'
import _ from 'lodash'
import { injectIntl } from 'react-intl'

class SunburstChart extends React.Component {
  constructor(props) {
    super(props)

    this.chartContainer = React.createRef();
  }

  componentDidMount() {
    this.draw()
  }

  draw() {
    const generateBaseItems = (myData, parentKey, childData) => {
      if (_.isArray(myData)) {
        myData = _.groupBy(myData, childData.dataKey)
      }

      return _.map(myData, (items, key) => {
        const total = _.sumBy(items, 'valor')

        const parsedKey = _.kebabCase(key)
        const id = _.includes(parentKey, parsedKey) ? _.split(parentKey, parsedKey).join(parsedKey) : `${ parentKey }-${ parsedKey }`
        const childItems = childData ? generateBaseItems(_.groupBy(items, childData.dataKey), id, childData.child) : []
        let baseItem = []

        if (!_.includes(parentKey, _.kebabCase(key))) {
          baseItem = [{ name: key, value: total, id, parent: parentKey }]
        }

        return [...baseItem, ...childItems ]
      });
    };
    const baseStructure = {
      dataKey: 'territorio',
      child: {
        dataKey: 'produto',
        child: {
          dataKey: 'ano'
        }
      }
    }
    const childItems = generateBaseItems(this.props.data, 'total', baseStructure);
    const data = _(childItems)
      .concat({
        name: this.props.intl.formatMessage({
          id: 'survey.charts.sunburst_total'
        }),
        id: 'total',
        color: 'white'
      })
      .flattenDeep()
      .value()
    const sampleItem = _.sample(this.props.data)

    Highcharts.chart(this.chartContainer.current, {
      chart: {
        height: '600',
        backgroundColor: '#F6F6F6'
      },
      title: {
        text: ''
      },
      credits: {
        text: `${ this.props.intl.formatMessage({ id: 'survey.source' }) } ${ this.props.intl.formatMessage({ id: this.props.legendTextKey }) }`,
        href: `javascript:window.open("${this.props.legendUrl}", "_blank")`
      },
      series: [{
        type: 'sunburst',
        data: data,
        allowDrillToNode: true,
        cursor: 'pointer',
        dataLabels: {
          format: '{point.name}',
          filter: {
            property: 'innerArcLength',
            operator: '>',
            value: 16
          }
        },
        levels: [
          {
            level: 1,
            levelIsConstant: false,
            dataLabels: {
              filter: {
                property: 'outerArcLength',
                operator: '>',
                value: 64
              }
            }
          }, {
            level: 2,
            colorByPoint: true
          },
          {
            level: 3,
            colorVariation: {
              key: 'brightness',
              to: -0.5
            }
          }, {
            level: 4,
            colorVariation: {
              key: 'brightness',
              to: 0.5
            }
          }
        ]
      }],
      tooltip: {
        pointFormat: '<b>{point.name}</b>: <b>{point.value:,.1f}</b>',
        footerFormat: `<span> ${ sampleItem.unidade }</span>`
      }
    })
  }

  render() {
    return (
      <div ref={ this.chartContainer } />
    )
  }
}

export default injectIntl(SunburstChart)



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchCharts/sunburst-chart.js